<template>
  <div class="custom-input input-box">
        <span class="prepend" v-if="$slots.prepend || label"><slot name="prepend">{{label}}</slot></span>
        <slot></slot>
        <div v-if="$slots.append" class="append" @click="()=>$emit('append-click')">
            <slot name="append"/>
        </div>
          <div v-if="$slots.appendOrther" class="appendOrther">
              <slot name="appendOrther"/>
        </div>
    </div>
</template>

<script>
export default {
    name:'CustomInput',
    props: ['label']
}
</script>

<style lang="scss" scoped>

.input-box {
    .append {
        display: inline-block;
        height: 100%;
        border-left: 1px solid #ccc;
        padding: 0 10px;
        cursor: pointer;
    }
    .appendOrther{
        display: inline-block;
        height: 100%;
        border-left: 1px solid #ccc;
        padding: 0 10px;
        cursor: pointer;
    }
}

</style>
